
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/video/[slug]",
      function () {
        return require("private-next-pages/video/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/video/[slug]"])
      });
    }
  